import { pull } from "lodash-es"
import { registerHotKeyTap } from "./registerHotkey"

type EscapeFn = () => void
type EscapeEntry = {
    name: string
    fn: EscapeFn
}

const escapeKeyFnCache: EscapeEntry[] = []
/**
 *
 * @param add
 * @returns function to remove the added function from the stack
 */
export const AddEscapeStack = (entry: EscapeEntry) => {
    escapeKeyFnCache.push(entry)
    return () => RemoveEscapeStack(entry)
}

export const RemoveEscapeStack = (entry: EscapeEntry) => {
    pull(escapeKeyFnCache, entry)
}

registerHotKeyTap("Escape", () => {
    const entry = escapeKeyFnCache.pop()
    // console.log("Popping: ", entry?.name)
    if (entry) entry.fn()
})
